// extracted by mini-css-extract-plugin
module.exports = {"Logo__link":"logo_Logo__link__I15TO","Logo__img":"logo_Logo__img___rcxL"};